import { render, staticRenderFns } from "./AwardExchangesTable.vue?vue&type=template&id=3e05b02c"
import script from "./AwardExchangesTable.vue?vue&type=script&lang=js"
export * from "./AwardExchangesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports